import React from "react";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { updateTextToImageThunk } from "../../apps/textToImageSlice";
import { textToImageSchema } from "../../validations";

const EditTextToImage = ({ textToImageItem, onClose }) => {
    const dispatch = useDispatch();
    const id = textToImageItem?._id; // Ensure textToImageItem exists before accessing `_id`

    // Formik Hook
    const formik = useFormik({
        initialValues: {
            id: textToImageItem?._id,
            prompt: textToImageItem?.prompt,
            aspect_ratio: textToImageItem?.aspect_ratio,
            uuid: textToImageItem?.uuid || "",
            imageUrl: textToImageItem?.imageUrl || "",
        },
        enableReinitialize: true, // Ensures Formik updates when TextToImage changes
        validationSchema: textToImageSchema,
        onSubmit: async (values) => {
            await dispatch(updateTextToImageThunk({ id, values }));
            onClose();
        },
    });

    return (
        <div className="container mx-auto p-6">
            <h2 className="text-2xl font-bold mb-4">Edit Text To Image</h2>

            <form onSubmit={formik.handleSubmit} className="bg-white shadow-md rounded-lg p-6">
                {/* ID */}
                <div className="p-2 rounded mb-2 border" >
                    <strong>id:</strong> {formik.values.id}
                </div>
                {/* Prompt */}
                <div>
                    <label className="block text-gray-700">Prompt</label>
                    <input
                        type="text"
                        name="prompt"
                        value={formik.values.prompt}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className="border p-2 w-full rounded-md mb-2"
                        required
                    />
                    {formik.touched.prompt && formik.errors.prompt && (
                        <p className="text-red-500 text-sm mb-4">{formik.errors.prompt}</p>
                    )}
                </div>

                {/* Aspect Ratio */}
                <div>
                    <label className="block text-gray-700">Aspect Ratio</label>
                    <input
                        type="text"
                        name="aspect_ratio"
                        value={formik.values.aspect_ratio}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className="border p-2 w-full rounded-md mb-2"
                        required
                    />
                    {formik.touched.title && formik.errors.aspect_ratio && (
                        <p className="text-red-500 text-sm mb-4">{formik.errors.aspect_ratio}</p>
                    )}
                </div>
                {/* UUID */}
                <div>
                    <label className="block text-gray-700">UUID</label>
                    <input
                        type="text"
                        name="uuid"
                        value={formik.values.uuid}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className="border p-2 w-full rounded-md mb-2"
                        readOnly
                    />
                    {formik.touched.uuid && formik.errors.uuid && (
                        <p className="text-red-500 text-sm mb-4">{formik.errors.uuid}</p>
                    )}
                </div>

                {/* Image URL */}
                <div>
                    <label className="block text-gray-700">Reference Image</label>
                    <input
                        type="text"
                        name="imageUrl"
                        value={formik.values.imageUrl}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className="border p-2 w-full rounded-md mb-2"
                        required
                    />
                    {formik.touched.imageUrl && formik.errors.imageUrl && (
                        <p className="text-red-500 text-sm mb-4">{formik.errors.imageUrl}</p>
                    )}

                </div>

                {/* Image Preview */}
                <div>
                    {formik.values.imageUrl && (
                        <img
                            src={formik.values.imageUrl}
                            alt="TextToImage"
                            className="w-40 h-40 object-cover rounded-md mb-4"
                        />
                    )}
                </div>

                {/* Image Preview */}
                {formik.values.thumb && (
                    <img
                        src={formik.values.thumb}
                        alt="TextToImage"
                        className="w-40 h-40 object-cover rounded-md mb-4"
                    />
                )}
                {/* Submit Button */}
                <button type="submit" className="bg-black text-white px-4 py-2 rounded-md">
                    Update TextToImage
                </button>
            </form>
        </div>
    );
};

export default EditTextToImage;
